import moment from "moment";

export const getYearsList = (yearsAhead = 5) => {
  const now = moment().utc();
  const startMoment = moment.utc(`${serverReference.constants.appointment.minYear}-01-01`);
  const endMoment = now.clone().add(yearsAhead, "years").startOf("year");
  const yearsDifference = endMoment.year() - startMoment.year();

  const years = [];
  for (let i = 0; i < yearsDifference; i++) {
    years.push(startMoment.clone().add(i, "years").year());
  }

  return years;
};

export interface PeriodOption {
  label: string
  value: number
}

type PeriodList = Array<{
  year: number
  entries: PeriodOption[]
}>;

export const getQuartersList = (yearsAhead = 5) => {
  const now = moment().utc();
  const startMoment = moment.utc(`${serverReference.constants.appointment.minYear}-01-01`);
  const endMoment = now.clone().add(yearsAhead, "years").startOf("year");
  const yearsDifference = endMoment.year() - startMoment.year();

  const quarters: PeriodList = [];
  for (let i = 0; i < yearsDifference; i++) {
    const firstQuarter = startMoment.clone().add(i, "years");
    const secondQuarter = firstQuarter.clone().add(3, "months");
    const thirdQuarter = secondQuarter.clone().add(3, "months");
    const fourthQuarter = thirdQuarter.clone().add(3, "months");
    const year = firstQuarter.year();
    quarters.push({
      year,
      entries: [
        {
          label: `${RESX.DateTime.Quarter1} ${year}`,
          value: firstQuarter.valueOf()
        },
        {
          label: `${RESX.DateTime.Quarter2} ${year}`,
          value: secondQuarter.valueOf()
        },
        {
          label: `${RESX.DateTime.Quarter3} ${year}`,
          value: thirdQuarter.valueOf()
        },
        {
          label: `${RESX.DateTime.Quarter4} ${year}`,
          value: fourthQuarter.valueOf()
        }
      ]
    });
  }

  return quarters;
};

export const getMonthsList = (yearsAhead = 5) => {
  const now = moment().utc();
  const startMoment = moment.utc(`${serverReference.constants.appointment.minYear}-01-01`);
  const endMoment = now.clone().add(yearsAhead, "years").startOf("year");
  const yearsDifference = endMoment.year() - startMoment.year();

  const months: PeriodList = [];
  for (let i = 0; i < yearsDifference; i++) {
    const currentYear = startMoment.clone().add(i, "years");
    months.push({
      year: currentYear.year(),
      entries: Array(12)
        .fill(0)
        .map((_, idx) => {
          const currentMonth = currentYear.clone().add(idx, "months");
          return {
            label: `${serverReference.monthNames[idx]} ${currentMonth.year()}`,
            value: currentMonth.valueOf()
          };
        })
    });
  }

  return months;
};

export const flatWeekList = (): number[] => {
  return Object.keys(serverReference.yearsWithWeeks).map(year => {
    return serverReference.yearsWithWeeks[year].map(time => {
      return time;
    });
  }).flat();
}

export const flattenPeriodList = (periodList: PeriodList) => {
  return periodList.reduce((acc, period) => {
    return acc.concat(period.entries.map(entry => entry.value));
  }, [] as number[]);
};